import React, { useState } from "react";
import classnames from "classnames";

const styles = require("./styles.module.scss");

type GeneralProps = {
  style?: any;
  className?: string;
  children: React.ReactNode;
};

type Props = GeneralProps & {
  heading: string;
  isLast?: boolean;
};

const Section: React.FC<Props> = ({
  heading,
  isLast = false,
  children,
  style = {},
  className = "",
}: Props) => {
  return (
    <section
      className={classnames(styles.section, isLast && styles.isLast, className)}
      style={style}
    >
      <h2 className={styles.sectionHeading}>{heading}</h2>
      {children}
    </section>
  );
};

export default Section;
